import {
  RADIOGRAPHER_PAGE_REQUEST_SUCCESS,
  RADIOGRAPHER_PAGE_REQUEST_FAIL,
  LOAD_RADIOGRAPHER_PAGE
} from '../action.types';

import initialState from '../initial.state';

export default function(state = initialState.radiographerpage, action) {
  switch (action.type) {
    case RADIOGRAPHER_PAGE_REQUEST_SUCCESS:
      return { ...action.payload.data };
    case RADIOGRAPHER_PAGE_REQUEST_FAIL:
      return state;
    case LOAD_RADIOGRAPHER_PAGE:
      return { ...action.radiographerpage };
    default:
      return state;
  }
}
